import { j as E } from "./jsx-runtime-944c88e2.js";
import * as u from "react";
import { p } from "./index-efd35e77.js";
import { l as O, v as S } from "./index-64063129.js";
import { B as P } from "./Button-4c83e316.js";
import { w as j, x as F } from "./index-93802845.js";
import { Y as L, Z as C, a as w, b as A, d as K, c as R, x as U } from "./index.es-6889c727.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./index-c07310bf.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
var k = function() {
  for (var o = [], n = 0; n < arguments.length; n++)
    o[n] = arguments[n];
  var r = {}, e = function(a) {
    return typeof a == "object" ? Object.keys(a).forEach(function(s) {
      r[s] = a[s];
    }) : r[a] = !0;
  }, t = function(a) {
    return a.filter(function(s) {
      return s !== !0 && !!s;
    }).map(function(s) {
      return Array.isArray(s) ? t(s) : e(s);
    });
  };
  return t(o), Object.keys(r).map(function(a) {
    return r[a] && a || null;
  }).filter(function(a) {
    return a !== null;
  }).join(" ");
}, z = function() {
  var o = "", n, r;
  for (n = 0; n < 32; n++)
    r = Math.random() * 16 | 0, (n === 8 || n === 12 || n === 16 || n === 20) && (o += "-"), o += (n === 12 ? 4 : n === 16 ? r & 3 | 8 : r).toString(16);
  return o;
};
function M(o) {
  if (typeof O < "u")
    S(o);
  else {
    var n = "License activation failed for ".concat(o.name, `
`);
    n += `The @progress/kendo-licensing script is not loaded.
`, n += "See ".concat(o.licensingDocsUrl, ` for more information.
`), console.warn(n);
  }
}
function m(o, n, r, e) {
  if (o) {
    var t = {
      syntheticEvent: n,
      nativeEvent: n.nativeEvent,
      target: r
    };
    o.call(void 0, Object.assign(t, e));
  }
}
var $ = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  orientationMap: {
    vertical: "vstack",
    horizontal: "hstack"
  }
}, T;
(function(o) {
  o.TOP = "top", o.BOTTOM = "bottom", o.LEFT = "left", o.RIGHT = "right", o.NONE = "none";
})(T || (T = {}));
var G = {
  name: "@progress/kendo-react-listbox",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1697040261,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, B = globalThis && globalThis.__extends || function() {
  var o = function(n, r) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }, o(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    o(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), D = globalThis && globalThis.__assign || function() {
  return D = Object.assign || function(o) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (o[t] = n[t]);
    }
    return o;
  }, D.apply(this, arguments);
}, H = (
  /** @class */
  function(o) {
    B(n, o);
    function n(r) {
      var e = o.call(this, r) || this;
      return e.setSelected = function(t) {
        if (e.props.selectedField)
          return !!t[e.props.selectedField];
      }, e.renderItem = function(t) {
        return e.props.textField ? t[e.props.textField] : t.toString();
      }, e.handleKeyDown = function(t) {
        e.props.onKeyDown && m(e.props.onKeyDown, t, e, void 0);
      }, e.handleContainerDrop = function(t) {
        var a = t.target, s = a.classList.contains("k-list-scroller");
        s && (e.props.data.length > 0 ? m(e.props.onDrop, t, e, { dataItem: e.props.data[e.props.data.length - 1] }) : m(e.props.onDrop, t, e, { dataItem: null }));
      }, e.setToolbarPosition = function() {
        return e.props.toolbarPosition === T.NONE || e.props.toolbar === void 0 ? "" : "k-listbox-actions-".concat(e.props.toolbarPosition);
      }, e.handleOnDragLeave = function(t) {
        e.props.onDragLeave && t.target.classList.contains("k-list-scroller") && m(e.props.onDragLeave, t, e, void 0);
      }, M(G), e;
    }
    return n.prototype.render = function() {
      var r, e = this;
      return u.createElement(
        "div",
        { className: k(this.props.className, "k-listbox", this.setToolbarPosition()), style: this.props.style, unselectable: "on" },
        this.props.toolbar && this.props.toolbarPosition !== "bottom" && u.createElement(this.props.toolbar, null),
        u.createElement(
          "div",
          { className: "k-list-scroller k-selectable", "data-role": "selectable", onDragOver: function(t) {
            return t.preventDefault();
          }, onDrop: this.handleContainerDrop, onDragLeave: this.handleOnDragLeave },
          u.createElement(
            "div",
            { className: k("k-list", (r = {}, r["k-list-".concat($.sizeMap[this.props.size] || this.props.size)] = this.props.size, r)) },
            u.createElement(
              "div",
              { className: "k-list-content" },
              u.createElement("ul", { className: "k-list-ul", role: "listbox", "aria-label": "listbox-container", tabIndex: 0, onKeyDown: this.handleKeyDown }, this.props.data.map(function(t, a) {
                var s = e.setSelected(t), i = z(), l = {
                  className: k("k-list-item", {
                    "k-selected": s
                  }),
                  role: "option",
                  "aria-selected": s,
                  key: a,
                  id: i + a,
                  "data-uid": i + a,
                  draggable: e.props.draggable,
                  onDragStart: function(c) {
                    return m(e.props.onDragStart, c, e, { dataItem: t });
                  },
                  onDragOver: function(c) {
                    c.preventDefault(), m(e.props.onDragOver, c, e, { dataItem: t });
                  },
                  onDrop: function(c) {
                    return m(e.props.onDrop, c, e, { dataItem: t });
                  },
                  onClick: function(c) {
                    return m(e.props.onItemClick, c, e, { dataItem: t });
                  }
                };
                return e.props.item ? u.createElement(
                  e.props.item,
                  D({ selected: s, dataItem: t }, l),
                  u.createElement("span", { className: "k-list-item-text" }, t.name)
                ) : u.createElement(
                  "li",
                  D({}, l),
                  u.createElement("span", { className: "k-list-item-text" }, e.renderItem(t))
                );
              }))
            )
          )
        ),
        this.props.toolbar && this.props.toolbarPosition === "bottom" && u.createElement(this.props.toolbar, null),
        u.createElement("select", { style: { display: "none" }, multiple: !0, "data-role": "listbox" }, this.props.data.map(function(t, a) {
          var s = t[e.props.valueField || e.props.textField];
          return u.createElement("option", { key: a, value: s }, s);
        }))
      );
    }, n.propTypes = {
      size: p.oneOf([null, "small", "medium", "large"]),
      toolbarPosition: p.oneOf(["none", "top", "bottom", "left", "right"]),
      textField: p.string,
      valueField: p.string,
      selectedField: p.string,
      data: p.array
    }, n.defaultProps = {
      toolbarPosition: T.RIGHT,
      draggable: !0,
      size: "medium"
    }, n;
  }(u.PureComponent)
), d, V = "listbox.moveUp", Y = "listbox.moveDown", Z = "listbox.transferTo", q = "listbox.transferFrom", J = "listbox.transferAllTo", Q = "listbox.transferAllFrom", W = "listbox.remove", X = (d = {}, d[V] = "Move Up", d[Y] = "Move Down", d[Z] = "Transfer To", d[q] = "Transfer From", d[J] = "Transfer All To", d[Q] = "Transfer All From", d[W] = "Delete", d), ee = globalThis && globalThis.__extends || function() {
  var o = function(n, r) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }, o(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    o(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), _ = [
  { name: "moveUp", iconName: "caret-alt-up", svgIcon: K },
  { name: "moveDown", iconName: "caret-alt-down", svgIcon: R },
  { name: "transferTo", iconName: "caret-alt-right", svgIcon: w },
  { name: "transferFrom", iconName: "caret-alt-left", svgIcon: A },
  { name: "transferAllTo", iconName: "caret-double-alt-right", svgIcon: L },
  { name: "transferAllFrom", iconName: "caret-double-alt-left", svgIcon: C },
  { name: "remove", iconName: "x", svgIcon: U }
], N = (
  /** @class */
  function(o) {
    ee(n, o);
    function n() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.checkSvgIcon = function(e) {
        switch (e.name) {
          case "caret-alt-right":
            return A;
          case "caret-alt-left":
            return w;
          case "caret-double-alt-right":
            return C;
          case "caret-double-alt-left":
            return L;
        }
        return e;
      }, r.checkFontIcon = function(e) {
        switch (e) {
          case "caret-alt-right":
            return "caret-alt-left";
          case "caret-alt-left":
            return "caret-alt-right";
          case "caret-double-alt-right":
            return "caret-double-alt-left";
          case "caret-double-alt-left":
            return "caret-double-alt-right";
        }
        return e;
      }, r.handleToolClick = function(e, t) {
        m(r.props.onToolClick, e, r, { toolName: t });
      }, r.isItemDisabled = function(e) {
        var t = !0, a = r.props.selectedField || "selected", s = r.props.data.length, i = r.props.dataConnected.length, l = r.props.data.findIndex(function(f) {
          return f[a] === !0;
        }) >= 0, c = r.props.dataConnected.findIndex(function(f) {
          return f[a] === !0;
        }) >= 0;
        switch (e) {
          case "moveUp":
            l ? t = r.props.data.length > 0 ? r.props.data[0].selected : !0 : c ? t = r.props.dataConnected.length > 0 ? r.props.dataConnected[0].selected : !0 : t = !0;
            break;
          case "moveDown":
            l ? t = r.props.data[s - 1] ? r.props.data[s - 1].selected : !0 : c ? t = r.props.dataConnected.length > 0 ? r.props.dataConnected[i - 1].selected : !0 : t = !0;
            break;
          case "transferTo":
            t = !(r.props.dataConnected && l);
            break;
          case "transferFrom":
            r.props.dataConnected ? t = !(r.props.dataConnected && c) : t = !0;
            break;
          case "transferAllTo":
            t = !(r.props.dataConnected && r.props.data.length > 0);
            break;
          case "transferAllFrom":
            t = !(r.props.dataConnected && r.props.dataConnected.length > 0);
            break;
          case "remove":
            t = !(l || c);
            break;
        }
        return t;
      }, r;
    }
    return Object.defineProperty(n.prototype, "isRtl", {
      get: function() {
        return this.props.dir === "rtl";
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.render = function() {
      var r = this, e = j(this);
      return u.createElement("div", { className: k("k-listbox-actions") }, this.props.tools && this.props.tools.map(function(t, a) {
        var s = _.findIndex(function(v) {
          return v.name === t;
        }), i = _[s], l = r.isItemDisabled(i.name), c = "listbox.".concat(i.name), f = e.toLanguageString(c, X[c]);
        return u.createElement(P, { key: a, disabled: l, "data-command": i.name, title: f, "aria-label": f, icon: r.isRtl ? r.checkFontIcon(i.iconName) : i.iconName, svgIcon: r.isRtl ? r.checkSvgIcon(i.svgIcon) : i.svgIcon, onClick: function(v) {
          v.preventDefault(), r.handleToolClick(v, i.name || null);
        } });
      }));
    }, n.propTypes = {
      data: p.array,
      dataConnected: p.array,
      tools: p.array,
      selectedField: p.string,
      dir: p.string
    }, n.defaultProps = {
      data: [],
      dataConnected: [],
      selectedField: "selected"
    }, n;
  }(u.PureComponent)
);
F(N);
var g = globalThis && globalThis.__spreadArray || function(o, n, r) {
  if (r || arguments.length === 2)
    for (var e = 0, t = n.length, a; e < t; e++)
      (a || !(e in n)) && (a || (a = Array.prototype.slice.call(n, 0, e)), a[e] = n[e]);
  return o.concat(a || Array.prototype.slice.call(n));
}, te = function(o, n, r, e) {
  o === void 0 && (o = []), n === void 0 && (n = []);
  var t = [], a = [], s = [], i = {
    listBoxOneData: o,
    listBoxTwoData: n
  };
  switch (r) {
    case "moveUp":
      t = g([], o, !0), t.forEach(function(l, c) {
        l[e] && (t = b(c, c - 1, t));
      }), s = g([], n, !0), s.forEach(function(l, c) {
        l[e] && (s = b(c, c - 1, s));
      }), i.listBoxOneData = t, i.listBoxTwoData = s;
      break;
    case "moveDown":
      t = o.reverse(), t.forEach(function(l, c) {
        l[e] && (t = b(c, c - 1, t));
      }), s = n.reverse(), s.forEach(function(l, c) {
        l[e] && (s = b(c, c - 1, s));
      }), i.listBoxOneData = g([], t, !0).reverse(), i.listBoxTwoData = g([], s, !0).reverse();
      break;
    case "transferTo":
      t = o.filter(function(l) {
        return !l[e];
      }), a = o.filter(function(l) {
        return l[e];
      }), s = n.concat(a), i.listBoxOneData = t, i.listBoxTwoData = s;
      break;
    case "transferFrom":
      s = n.filter(function(l) {
        return !l[e];
      }), a = n.filter(function(l) {
        return l[e];
      }), t = o.concat(a), i.listBoxOneData = t, i.listBoxTwoData = s;
      break;
    case "transferAllTo":
      i.listBoxOneData = [], i.listBoxTwoData = n.concat(o);
      break;
    case "transferAllFrom":
      i.listBoxOneData = n.concat(o), i.listBoxTwoData = [];
      break;
    case "remove":
      s = n.filter(function(l) {
        return !l[e];
      }), t = o.filter(function(l) {
        return !l[e];
      }), i.listBoxOneData = t, i.listBoxTwoData = s;
      break;
  }
  return i;
}, b = function(o, n, r) {
  var e = r.splice(o, 1)[0];
  return r.splice(n, 0, e), r;
}, re = function(o, n, r, e, t) {
  o === void 0 && (o = []), n === void 0 && (n = []);
  var a = o.findIndex(function(h) {
    return h[t] === r[t];
  }), s = n.findIndex(function(h) {
    return h[t] === r[t];
  }), i = e !== null ? o.findIndex(function(h) {
    return h[t] === e[t];
  }) : -1, l = e !== null ? n.findIndex(function(h) {
    return h[t] === e[t];
  }) : -1, c = a >= 0, f = s >= 0, v = i >= 0, x = l >= 0, y = g([], o, !0), I = g([], n, !0);
  return c && v ? {
    listBoxOneData: b(a, i, o),
    listBoxTwoData: n
  } : f && x ? {
    listBoxOneData: o,
    listBoxTwoData: b(s, l, n)
  } : c && (x || e === null) ? (e === null ? I.push(o[a]) : I.splice(l + 1, 0, o[a]), y.splice(a, 1), {
    listBoxOneData: y,
    listBoxTwoData: I
  }) : f && (v || e === null) ? (e === null ? y.push(n[s]) : y.splice(i + 1, 0, n[s]), I.splice(s, 1), {
    listBoxOneData: y,
    listBoxTwoData: I
  }) : {
    listBoxOneData: o,
    listBoxTwoData: n
  };
};
const me = te, ve = re, he = (o) => /* @__PURE__ */ E.jsx(H, { ...o }), ge = (o) => /* @__PURE__ */ E.jsx(N, { ...o });
export {
  he as ListBox,
  ge as ListBoxToolbar,
  me as processListBoxData,
  ve as processListBoxDragAndDrop
};
